import { Outlet } from "@tanstack/react-router";

export function RootShell() {
  return (
    <>
      {/*
        First tab stop on every page. A dashboard's nav is a dozen links, and
        without this a keyboard user walks all of them before reaching the
        table they came for — WCAG 2.4.1.
      */}
      <a
        href="#main"
        className="sr-only focus:not-sr-only focus:absolute focus:left-3 focus:top-3 focus:z-50 focus:rounded-lg focus:bg-raised focus:px-3 focus:py-2 focus:text-sm focus:shadow"
      >
        Skip to content
      </a>
      <Outlet />
    </>
  );
}
